import request from "@/utils/request";

/**
 * 查询合同列表
 * @param params
 * @returns {*}
 */
export function getContractList(params) {
  return request({
    url: "/api/backend/contract/getContractList",
    method: "get",
    params
  });
}

/**
 * 新建/修改合同
 * @param params
 * @returns {*}
 */
export function createContract(params) {
  return request({
    url: "/api/backend/contract/createContract",
    method: "post",
    data: params
  });
}
